import React, { useState } from 'react';
import {
  Anchor, Button, Center, Paper, PasswordInput,
  Stack, Text, TextInput, Title,
} from '@mantine/core';

function LoginPage({ onLogin, onShowRegister }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [vergeten, setVergeten] = useState(false);
  const [vergetenBericht, setVergetenBericht] = useState('');

  const vraagReset = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await fetch('/api/wachtwoord-vergeten', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username }),
      });
      const data = await response.json();
      if (response.ok) setVergetenBericht(data.message);
      else setError(data.error || 'Aanvragen mislukt');
    } catch {
      setError('Netwerkfout');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await response.json();
      if (data.success) onLogin(data);
      else setError(data.error || 'Login mislukt');
    } catch {
      setError('Netwerkfout');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Center
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #e8f8ef 0%, #d0efdd 100%)',
      }}
    >
      <Paper
        component="form"
        p="xl"
        shadow="md"
        radius="md"
        withBorder
        style={{ width: 380, maxWidth: '90vw' }}
        autoComplete="on"
        action="/login"
        method="post"
        onSubmit={handleSubmit}
      >
        <Stack gap="md">
          <Title order={2} c="groen.7" ta="center">
            {vergeten ? 'Wachtwoord vergeten' : 'Inloggen'}
          </Title>

          <TextInput
            id="username-text-field"
            name="username"
            type="email"
            label="E-mailadres"
            placeholder="naam@organisatie.nl"
            description="Log in met je e-mailadres"
            value={username}
            onChange={e => setUsername(e.currentTarget.value)}
            autoFocus
            autoComplete="username"
            required
          />

          {!vergeten && (
            <PasswordInput
              id="password-text-field"
              name="password"
              label="Wachtwoord"
              placeholder="Wachtwoord"
              value={password}
              onChange={e => setPassword(e.currentTarget.value)}
              autoComplete="current-password"
              required
            />
          )}

          {error && <Text c="red" size="sm">{error}</Text>}
          {vergeten && vergetenBericht && <Text c="groen.7" size="sm">{vergetenBericht}</Text>}

          {vergeten ? (
            <Button type="button" loading={loading} fullWidth
              onClick={vraagReset} disabled={!username.trim()}>
              Stuur resetlink
            </Button>
          ) : (
            <Button type="submit" loading={loading} fullWidth>
              Inloggen
            </Button>
          )}

          <Text size="sm" ta="center" c="dimmed">
            {vergeten ? (
              <Anchor component="button" type="button"
                onClick={() => { setVergeten(false); setVergetenBericht(''); setError(''); }}>
                Terug naar inloggen
              </Anchor>
            ) : (
              <>
                <Anchor component="button" type="button"
                  onClick={() => { setVergeten(true); setError(''); }}>
                  Wachtwoord vergeten?
                </Anchor>
                {' · '}
                Nog geen account?{' '}
                <Anchor component="button" type="button" onClick={onShowRegister}>
                  Registreren
                </Anchor>
              </>
            )}
          </Text>
        </Stack>
      </Paper>
    </Center>
  );
}

export default LoginPage;
